const usTimezones = [
    "America/New_York",
    "America/Chicago",
    "America/Denver",
    "America/Phoenix",
    "America/Los_Angeles",
    "America/Anchorage",
    "America/Adak",
    "Pacific/Honolulu"
];

function isUSTimezone() {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return usTimezones.includes(userTimezone);
}

function getVariantId() {

    const inputElement = document.querySelector(".store-availability-container__wrapper")
    if (inputElement) {
        const value = inputElement.getAttribute('data-variant-id');
        if (value) {
            console.log("Value: ", value)
            sendHTTPRequest(value);
        } else {
            setTimeout(() => {
                handleVariantChange();
            }, 500);
        }
    } else {
        console.log("Element not found");
        setTimeout(() => {
            handleVariantChange();
        }, 500);
    }
}

// 创建库存信息元素的函数
function createInventoryElement(data) {
    const newDiv = document.createElement("div");
    newDiv.classList.add("Inventory-quantity");
    const newSpan = document.createElement("span");
    const newI = document.createElement("i");
    if (data > 10) {
        newSpan.textContent = "Available in U.S. warehouse";
        newI.classList.add("safe");
    } else if (data >= 1) {
        const dataSpan = document.createElement('span');
        dataSpan.textContent = data;
        dataSpan.style.color = '#F2733A';
        dataSpan.style.fontWeight = "bold";
        newSpan.appendChild(document.createTextNode('Only '));
        newSpan.appendChild(dataSpan);
        newSpan.appendChild(document.createTextNode('  left in U.S. warehouse'));
        newI.classList.add("danger");
    }
    newDiv.appendChild(newI);
    newDiv.appendChild(newSpan);
    return newDiv;
}

// 物流到达时间
function createShippingElement(data) {
    const newDiv = document.createElement("div");
    newDiv.classList.add("Shipping-time");
    newDiv.style.margin = '10px 0px 20px 0px';
    const newSpan = document.createElement("span");
    if (data >= 1) {
        const now = new Date();
        // const now = new Date(new Date('2026-03-12T07:10:00'));
        const endOfDay = new Date(now).setHours(23, 59, 59, 999);
        let hours, minutes;
        let shipDate = new Date(now); 
        shipDate.setDate(shipDate.getDate() + 1);
        const diffToday = endOfDay - now;
        const totalMinutesToday = Math.floor(diffToday / (1000 * 60));
        hours = Math.floor(totalMinutesToday / 60);
        minutes = totalMinutesToday % 60;
        const timeSpan = document.createElement('span');
        timeSpan.textContent = `${hours} hrs ${minutes} mins`;
        timeSpan.style.color = '#2E7D32'; 
        timeSpan.style.fontWeight = "bold";
        
        newSpan.innerHTML = ''; 
        newSpan.appendChild(document.createTextNode('Order within '));
        newSpan.appendChild(timeSpan);
        
        // 定义节假日数组 (格式: MM-DD)
        const holidays = [
            '12-25', // 圣诞节
            '01-01', // 元旦
            '11-26' // 感恩节 ()
        ];
        
        // 检查日期是否为节假日或周末
        function isHolidayOrWeekend(date) {
            const monthDay = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
            const dayOfWeek = date.getDay();
            return holidays.includes(monthDay) || dayOfWeek === 0 || dayOfWeek === 6; 
        }
        
        // 计算日期
        function calculateDeliveryDate(startDate, businessDays) {
            const deliveryDate = new Date(startDate);
            while (isHolidayOrWeekend(deliveryDate)) {
                deliveryDate.setDate(deliveryDate.getDate() + 1);
            }
            deliveryDate.setDate(deliveryDate.getDate() + businessDays)
            return deliveryDate;
        }
        function calculateDeliveryDate2(startDate, businessDays) {
            const deliveryDate = new Date(startDate);
            for (let adddays = 0; adddays < businessDays; deliveryDate.setDate(deliveryDate.getDate() + 1)){
                if (!isHolidayOrWeekend(deliveryDate)) {
                    adddays++;
                }
            }
            while (isHolidayOrWeekend(deliveryDate)) {
                deliveryDate.setDate(deliveryDate.getDate() + 1);
            }
            return deliveryDate;
        }
        
        // 格式化日期为 "Month Day" 格式
        function formatDateToMonthDay(date) {
            const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 
                                'July', 'August', 'September', 'October', 'November', 'December'];
            const month = monthNames[date.getMonth()];
            const day = date.getDate();
            return `${month} ${day}`;
        }
        
        // 查看更多物流
        const seeMoreLink = document.createElement('span');
        seeMoreLink.style.fontSize = '12px';
        seeMoreLink.style.marginLeft = '10px';
        seeMoreLink.style.f
        seeMoreLink.style.color = '#FF6C11';
        seeMoreLink.style.cursor = 'pointer';
        seeMoreLink.textContent = 'See more delivery options ▼';
        // 收起
        const collapseLink = document.createElement('span');
        collapseLink.style.fontSize = '12px';
        collapseLink.style.marginLeft = '50px';
        collapseLink.style.color = '#FF6C11';
        collapseLink.style.cursor = 'pointer';
        collapseLink.textContent = 'Collapse ▲';
        collapseLink.style.display = 'none';

        seeMoreLink.addEventListener('click', function() {
            expeditedDiv.style.display = 'block';
            seeMoreLink.style.display = 'none';
            collapseLink.style.display = 'inline';
        });
        collapseLink.addEventListener('click', function() {
            expeditedDiv.style.display = 'none';
            seeMoreLink.style.display = 'inline';
            collapseLink.style.display = 'none';
        });

        // 创建 USPS 信息
        const expeditedDiv = document.createElement('div');
        expeditedDiv.style.marginTop = '5px';
        
        const expeditedStrong = document.createElement('strong');
        const expeditedStartDate = new Date(shipDate);
        const expeditedDeliveryDate = calculateDeliveryDate(expeditedStartDate, 5);
        expeditedStrong.textContent = formatDateToMonthDay(expeditedDeliveryDate);
        expeditedStrong.style.color = '#2E7D32'; 
        
        expeditedDiv.appendChild(document.createTextNode('Free USPS : Estimated delivery by '));
        expeditedDiv.appendChild(expeditedStrong);
        expeditedDiv.appendChild(collapseLink);
        expeditedDiv.style.display = 'none';
        
        // 创建 Express 信息
        const expressDiv = document.createElement('div');
        expressDiv.style.marginTop = '3px';
        
        const expressStrong = document.createElement('strong');
        const expressStartDate = new Date(shipDate);
        const expressDeliveryDate = calculateDeliveryDate2(expressStartDate, 2);
        expressStrong.textContent = formatDateToMonthDay(expressDeliveryDate);
        expressStrong.style.color = '#2E7D32'; 
        
        expressDiv.appendChild(document.createTextNode('Expedited : Estimated delivery by '));
        expressDiv.appendChild(expressStrong);

        const mediaQuery = window.matchMedia('(min-width: 750px)');

        function positionSeeMoreLink(e) {
            if (e.matches) {
                if (!expressDiv.contains(seeMoreLink)) {
                    expressDiv.appendChild(seeMoreLink);
                    seeMoreLink.style.display = 'inline';
                    collapseLink.display = 'inline';
                    expeditedDiv.style.display = 'none';
                }
            } else {
                seeMoreLink.style.display = 'none';
                collapseLink.display = 'none';
                expeditedDiv.style.display = 'block';
            }
        }
        positionSeeMoreLink(mediaQuery);
        // mediaQuery.addListener(positionSeeMoreLink);
        mediaQuery.addEventListener('change', positionSeeMoreLink);
        newDiv.appendChild(newSpan);
        newDiv.appendChild(expressDiv);
        newDiv.appendChild(expeditedDiv);
    } 
    return newDiv;
}

async function sendHTTPRequest(variantId) {
    try {
        const response = await fetch(`https://api.fullshine.net?variantId=${variantId}`);
        const data = await response.json();
        console.log("request data: ", data)
        const existingInventoryQuantity = document.querySelector('.Inventory-quantity');
        if (existingInventoryQuantity) {
            existingInventoryQuantity.remove();
        }
        const targetElement = document.querySelector('.product__controls-group-quantity')
        if (targetElement) {

            // 使用 window.matchMedia 检测屏幕宽度是否大于 750px
            const mediaQuery = window.matchMedia('(min-width: 750px)');
            // 定义一个函数来处理样式设置
            function setStyles() {
                if (mediaQuery.matches) {
                    // 当屏幕宽度大于 750px 时设置样式
                    targetElement.style.display = 'flex';
                    targetElement.style.justifyContent = 'flex-start';
                    targetElement.style.alignItems = "center";
                } else {
                    // 当屏幕宽度小于等于 750px 时移除样式（可选）
                    targetElement.style.display = '';
                    targetElement.style.justifyContent = '';
                    targetElement.style.alignItems = '';
                }
            }
            // 初始调用函数以设置初始样式
            setStyles();
            // 监听媒体查询的变化，当屏幕宽度改变时重新设置样式
            mediaQuery.addEventListener('change', setStyles);
            let newBox = targetElement.querySelector('.Out-box');
            if (!newBox) {
                // 创建新的包裹盒子
                newBox = document.createElement("div");
                newBox.classList.add('Out-box');
        
                // 获取需要包裹的元素
                const quantityText = document.querySelector(".product__controls-group-quantity .product__label-wrapper");
                const quantityBotton = document.querySelector(".product__controls-group-quantity .product__item");
        
                // 将元素添加到新盒子中
                newBox.appendChild(quantityText);
                newBox.appendChild(quantityBotton);
        
                // 将新盒子插入到目标元素中，与 Inventory-quantity 同级
                targetElement.insertBefore(newBox, targetElement.firstChild);
            }

            const newDiv = document.createElement("div");
            newDiv.classList.add("Inventory-quantity");
            const newSpan = document.createElement("span");
            const newI = document.createElement("i")
            if (data > 10) {
                newSpan.textContent = "Available in U.S. warehouse";
                newI.classList.add("safe");
            } else if (data >= 1) {
                // 创建一个新的 span 元素来包裹 data
                const dataSpan = document.createElement('span');
                dataSpan.textContent = data;
                dataSpan.style.color = '#FF6C11';
                dataSpan.style.fontWeight = "bold"
    
                // 拼接文本内容
                newSpan.appendChild(document.createTextNode('Only '));
                newSpan.appendChild(dataSpan);
                newSpan.appendChild(document.createTextNode('  left in U.S. warehouse'));
                newI.classList.add("danger");
            }
            newDiv.appendChild(newI);
            newDiv.appendChild(newSpan);
            targetElement.appendChild(newDiv);

            const existingShipping = document.querySelector('.Shipping-time');
            if (existingShipping) {
                existingShipping.remove();
            }
            if (window.shippingRefreshInterval) {
                clearInterval(window.shippingRefreshInterval);
            }
            // 添加物流时间预估
            if(data > 0) {
                let targetElements = document.querySelector('.product__controls-group-quantity');
                const shippingDiv = createShippingElement(data);
                if (targetElements) {
                    targetElements.insertAdjacentElement('afterend', shippingDiv);
                }else {
                    const observer1 = new MutationObserver((mutationsList) => {
                        for (const mutation of mutationsList) {
                            if (mutation.type === 'childList') {
                                const swatches = getDiv();
                                if (swatches) {
                                    observer1.disconnect();
                                    swatches.insertAdjacentElement('afterend', shippingDiv);
                                    break;
                                }
                            }
                        }
                    });
                    observer1.observe(document.body, { childList: true, subtree: true });
                }
                window.shippingRefreshInterval = setInterval(async () => {
                    const existingShipping = document.querySelector('.Shipping-time');
                    if (existingShipping) {
                        try {
                            const newShippingElement = createShippingElement(data);
                            existingShipping.replaceWith(newShippingElement);
                        } catch (error) {
                            console.error('Refresh error:', error);
                        }
                    }
                },60000);
            }
        }
    } catch (error) {
        console.error('Fetch error:', error);
    }
}

async function handleVariantChange() {
    if (!isUSTimezone()) {
        console.log('The user is not in the US and does not perform follow-up actions');
        return;
    }
    await getVariantId();
}

handleVariantChange();
const targetElementClick = document.querySelector('.store-availability-container__wrapper');

if (targetElementClick) {
    // 创建一个 MutationObserver 实例
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-variant-id') {
                // 当 data-variant-id 属性发生变化时执行相应操作
                const newVariantId = targetElementClick.dataset.variantId;
                // 在这里调用你的处理函数
                handleVariantChange();
            }
        }
    });

    // 配置观察选项，这里只观察属性变化，并且指定要观察的属性为 data-variant-id
    const config = { attributes: true, attributeFilter: ['data-variant-id'] };

    // 开始观察目标元素
    observer.observe(targetElementClick, config);
}